import * as BABYLON from "babylonjs";
import "babylonjs-loaders";

export default class AssetLoader {
  static loadCache = {
    models: {},
    envs: {},
    textures: {},
    images: {},
    data: {},
    containers: {},
  };
  static objectCache = {
    models: {},
    envs: {},
    textures: {},
    images: {},
    data: {},
    containers: {},
  };

  static load = (assets, scene) => {
    let arr = [];
    if (assets.models) {
      arr.push(AssetLoader.loadModels(assets.models, scene));
    }
    if (assets.environments) {
      arr.push(AssetLoader.loadEnvironments(assets.environments, scene));
    }
    if (assets.textures) {
      arr.push(AssetLoader.loadTextures(assets.textures, scene));
    }
    if (assets.images) {
      arr.push(AssetLoader.loadImages(assets.images));
    }
    if (assets.data) {
      arr.push(AssetLoader.loadDataList(assets.data));
    }
    if (assets.containers, scene) {
      arr.push(AssetLoader.loadContainers(assets.containers));
    }
    return Promise.all(arr);
  };

  static loadModels = (models, scene) =>
    Promise.all(
      Object.keys(models).map((key) => this.loadModel(key, models[key], scene))
    );

  static loadModel = (key, path) =>
    (AssetLoader.loadCache.models[key] =
      AssetLoader.loadCache.models[key] ||
      new Promise((resolve) => {
        console.log(`Loading model ${key}: ${path}`);
        BABYLON.SceneLoader.ImportMesh(
          "",
          path,
          "",
          this.scene,
          function (meshes, particleSystems, skeletons, animationGroups) {
            const animations = {};
            if (animationGroups.length > 0) {
              animationGroups[0].stop();
              animationGroups.forEach((item) => {
                animations[item.name] = item;
              });
            }

            // ALEX HACK - hide preloaded glbs
            if (
              key === "DriftsCave" ||
              key === "IcewallsCave" ||
              key === "Stalagmites" ||
              key === "Geodes" ||
              key === "Mounds" ||
              key === "Snowball" ||
              key === "IcePatch" ||
              key === "Star" ||
              key === "Watch" ||
              key === "Headphones" ||
              key === "Phone"
            ) {
              meshes.forEach((item) => {
                item.isVisible = false;
                item.getChildren((mesh) => {
                  mesh.isVisible = false;
                }, false);
              });
            }

            resolve(
              (AssetLoader.objectCache.models[key] = {
                meshes,
                particleSystems,
                skeletons,
                animations,
              })
            );
          }
        );
      }));

  static getModel = (key) => AssetLoader.objectCache.models[key];

  static loadTextures = (textures, scene) => {
    return Promise.all(
      Object.keys(textures).map((key) => {
        return this.loadTexture(key, textures[key], scene);
      })
    );
  };

  static loadTexture = (key, path, scene) =>
    (AssetLoader.loadCache.textures[key] =
      AssetLoader.loadCache.textures[key] ||
      new Promise((resolve) => {
        console.log(`Loading texture ${key}: ${path}`);
        const texture = new BABYLON.Texture(path, scene);
        BABYLON.Texture.WhenAllReady([texture], () => {
          AssetLoader.objectCache.textures[key] = texture;
          resolve();
        });
      }));

  static getTexture = (key) => AssetLoader.objectCache.textures[key];

  static loadImages = (images) => {
    return Promise.all(
      Object.keys(images).map((key) => {
        return this.loadImage(key, images[key]);
      })
    );
  }

  static loadImage = (key, path) =>
    (AssetLoader.loadCache.images[key] =
      AssetLoader.loadCache.images[key] ||
      new Promise((resolve) => {
        const image = new Image()
        image.src = path
        image.onload = () => {
          AssetLoader.objectCache.images[path] = image;
          resolve();
        }
      }));

  static getImage = (key) => AssetLoader.objectCache.images[key];

  static loadEnvironments = (envs, scene) => {
    return Promise.all(
      Object.keys(envs).map((key) => {
        return this.loadEnvironment(key, envs[key], scene);
      })
    );
  };

  static loadEnvironment = (key, url, scene) =>
    (AssetLoader.loadCache.envs[key] =
      AssetLoader.loadCache.envs[key] ||
      new Promise((resolve) => {
        console.log(`Loading environment ${key}: ${url}`);
        const texture = new BABYLON.CubeTexture.CreateFromPrefilteredData(
          url,
          scene
        );
        BABYLON.CubeTexture.WhenAllReady([texture], () => {
          AssetLoader.objectCache.envs[key] = texture;
          resolve();
        });
      }));

  static getEnvironment = (key) => {
    return AssetLoader.objectCache.envs[key];
  };

  static loadDataList = (data) => {
    return Promise.all(
      Object.keys(data).map((key) => {
        return this.loadData(key, data[key]);
      })
    );
  };

  static loadData = (key, path) =>
    (AssetLoader.loadCache.data[key] =
      AssetLoader.loadCache.data[key] ||
      new Promise((resolve) => {
        console.log(`Loading texture ${key}: ${path}`);
        fetch(path)
          .then((response) => {
            return response.json();
          })
          .then(({ data }) => {
            AssetLoader.objectCache.data[key] = data;
            resolve();
          });
      }));

  static getData = (key) => {
    return AssetLoader.objectCache.data[key];
  };

  static loadContainers = (containers, scene) => {
    return Promise.all(
      Object.keys(containers).map((key) => {
        return this.loadContainer(key, containers[key], scene);
      })
    );
  };

  static loadContainer = (key, path, scene) =>
    (AssetLoader.loadCache.containers[key] =
      AssetLoader.loadCache.containers[key] ||
      new Promise((resolve) => {
        console.log(`Loading container ${key}: ${path}`);
        BABYLON.SceneLoader.LoadAssetContainer(path, "", scene, (assets) => {
          console.log('Assets:', assets)
          AssetLoader.objectCache.containers[key] = assets;
          resolve();
        })
      }));

  static getContainer = (key) => {
    return AssetLoader.objectCache.containers[key];
  };
}
